import { render, staticRenderFns } from "./BlockDialog.vue?vue&type=template&id=6529fa1c"
import script from "./BlockDialog.vue?vue&type=script&lang=js"
export * from "./BlockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports